import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../../../helpers/reducerRegistry'
import { valByKeyWithDot } from '../../../../../../helpers/value'
import {
  convertDataApi,
  filterItemsWithAllValuesDefined,
} from '../../../helper'
import { getBankEarningBreakdownThunk } from './thunk'

const initialState = {
  dataViewByTrend: [],
  dataViewByEachYear: {},
  idTable: [],
  byIdTable: {},
  years: [],
  loading: true,
  indicator: [],
  indicatorById: {},
}

const slice = createSlice({
  name: 'companyAnalysis/financialAnalysis/bank/earningBreakdown',
  initialState: initialState,
  reducers: {
    resetStoreBankEarningBreakdown: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getBankEarningBreakdownThunk.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getBankEarningBreakdownThunk.fulfilled, (state, action) => {
      const data = convertDataApi(
        filterItemsWithAllValuesDefined(action.payload),
      )

      Object.keys(data).forEach((key) => {
        state[key] = data[key]
      })

      state.loading = false
    })
    builder.addCase(getBankEarningBreakdownThunk.rejected, (state) => {
      state.loading = false
    })
  },
})

export const { resetStoreBankEarningBreakdown } = slice.actions

export const selectLoading = (state) => state[slice.name].loading

export const selectIdTable = (state) => state[slice.name].idTable

export const selectByIdTable = (state) => state[slice.name].byIdTable

export const selectCell = (id, attr) => (state) =>
  valByKeyWithDot(state[slice.name].byIdTable[id], attr)

export const selectYears = (state) => state[slice.name].years

export const selectDataViewByTrend = (state) =>
  state[slice.name].dataViewByTrend

export const selectDataViewByEachYear = (year) => (state) =>
  state[slice.name].dataViewByEachYear[year] || []

export const selectIndicator = (state) => state[slice.name].indicator

export const selectIndicatorById = (state) => state[slice.name].indicatorById

register(slice.name, slice.reducer)
